import * as React from 'react';

import LifestyleForm from './LifestyleForm';
import Utils from '../../../common/utils';

interface Props {
	user: UserDetails;
	customerDetails: CustomerDemographicDetails;
	customerPolicy: CustomerPolicy;
	questionnaire: any;
	actions: any;
	history: any;
	match: any;
	className?: string;
	onQuestionnaireBlur: (e: any) => Promise<any>;
	onQuestionnaireChange: (e: any) => void;
	onQuestionnaireNumberKeyUp: (e: any) => void;
}
class LifestylePage extends React.Component<Props> {
	onOwnPetsTypesBlur = (e?: any) => {
		return this.props.actions
			.saveCustomerPolicyAnswer(this.props.customerPolicy.id, 'ownPetsTypes', this.props.questionnaire.ownPetsTypes);
	}

	onOwnPetsTypesChange = (e: any) => {
		const value = Utils.parseValueFromEvent(e);

		const ownPetsTypes = {
			...this.props.questionnaire.ownPetsTypes,
			[e.target.name]: value
		};

		const questionnaire = {
			...this.props.questionnaire,
			ownPetsTypes
		};

		this.props.actions.setQuestionnaire(questionnaire);
	}

	back = () => {
		this.props.history.push(`/quote/${this.props.match.params.workflow}/enrollment/basics#3`);
	}

	next = () => {
		this.props.history.push(`/quote/${this.props.match.params.workflow}/enrollment/activities`);
	}

	render() {
		return (
			<LifestyleForm
				{...this.props}
				onOwnPetsTypesBlur={this.onOwnPetsTypesBlur}
				onOwnPetsTypesChange={this.onOwnPetsTypesChange}
				parentNext={this.next}
				parentPrev={this.back}
			/>
		);
	}
}

export default LifestylePage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/LifestylePage.tsx